import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Snowflake, Loader2 } from "lucide-react";

const BG =
  "https://images.unsplash.com/photo-1615309662243-70f6df917b59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxhaXIlMjBjb25kaXRpb25pbmclMjBodmFjJTIwc3lzdGVtJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4MjkwMTc1OHww&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("ms-energie@outlook.fr");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="relative hidden lg:block lg:w-1/2">
        <img src={BG} alt="Installation climatisation" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/60" />
        <div className="relative z-10 h-full flex flex-col justify-end p-12 text-white">
          <Snowflake size={40} className="mb-4 text-[#38bdf8]" />
          <h1 className="font-heading text-4xl font-extrabold leading-tight">
            Gérez vos chantiers clim & chauffage
          </h1>
          <p className="mt-3 text-lg text-slate-200 max-w-md">
            Devis rapides, facturation propre, PDF professionnels. Prêt pour le terrain.
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 bg-slate-50">
        <div className="w-full max-w-md">
          <div className="mb-8 flex flex-col items-center text-center">
            <img src="/logo.png" alt="MS ÉNERGIE" className="h-16 w-auto object-contain mb-2" />
            <div className="text-sm text-[#16A34A] font-semibold">Espace administrateur</div>
          </div>

          <form onSubmit={submit} className="space-y-5 bg-white p-6 rounded-md border border-slate-200">
            <div className="space-y-2">
              <Label htmlFor="email" className="font-semibold">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email-input"
                className="h-12 text-base"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="font-semibold">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                className="h-12 text-base"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
                {error}
              </div>
            )}
            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full h-12 text-lg font-bold bg-[#16A34A] hover:bg-[#15803D]"
            >
              {loading ? <Loader2 className="animate-spin" /> : "Se connecter"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
